export default __webpack_public_path__ + "static/media/9.af3e32d4.png";